import baseRoute from '../baseRoute';

export default `${baseRoute}/fieldReportAssignmentHistory` as const;
